module.exports = __webpack_public_path__ + "media/newstyle/images/icon-profile-red-d116ec1e4be49a08029c229f1ebce0bb.svg";